export default class AuctionViewing {
  public from: Date;
  public to: Date;

  constructor(obj: any) {
    this.from = new Date(obj.from);
    this.to = new Date(obj.to);
  }
}
